<template>
    <div class="time" :class="timeStyle">
        <div class="glow"/>
        <div class="task">
            <div class="content">
                <div class="status">
                    {{ status }}
                    <span v-show="location.options.is_round_trip" class="round-trip">來回件</span>
                </div>
                <div class="address" v-show="location.alias">{{ location.district + location.road + ' ' + location.additional }}</div>
                <div class="description" :class="{blue: isWaitGoLocation}" v-html="description">
                </div>
            </div>
            <div class="buttons">

            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        name: 'Time',
        props: {
            location: {
                default: {},
                required: true,
            },
            locationIndex: {
                default: 0,
                required: true,
            },
            locations: {
                default: [],
                required: true,
            },
            order: {
                default: {},
                required: true,
            },
            isWaitGoLocation: {
                default: false,
            }
        },
        computed: {
            status() {
                if (this.isWait || this.isDone || this.isWaitGoLocation) {
                    return this.location.alias ?
                        (this.locationIndex + 1) + '. ' + this.location.alias :
                        (this.locationIndex + 1) + '. ' + this.location.district + this.location.road + ' ' + this.location.additional;
                }

                return this.location.arrived_at ?
                    this.location.arrived_at.slice(11, 16) + ' 已抵達' :
                    '正在前往中';
            },
            description() {
                if (this.isWait) {
                    let estimateTime = moment(this.order.estimated_time);
                    return (this.isLast && this.isProcessing && !this.isWaitGoLocation) ? '預計 ' + (estimateTime.isSame(moment(), 'day') ? estimateTime.format('HH:mm') : estimateTime.format('MM/DD HH:mm')) + ' 抵達' : '&nbsp;';
                }

                if (this.isDone) {
                    let time = moment(this.location.left_at);
                    time = time.isSame(moment(), 'day') ? time.format('HH:mm') : time.format('MM/DD HH:mm');

                    return this.location.behalf_price ? `${time} 已離開，代付 ${this.location.behalf_price}$` : `${time} 已離開`;
                }

                return this.isStandBy ?
                    '預計 ' + this.reservedAt + ' 抵達' :
                    this.location.alias ?
                        (this.locationIndex + 1) + '. ' + this.location.additional + ' ' + this.location.alias :
                        (this.locationIndex + 1) + '. ' + this.location.district + this.location.road + ' ' + this.location.additional;
            },
            isProcessing() {
                return this.order.status === 'processing';
            },
            previous() {
                return this.locations[this.locationIndex - 1];
            },
            isDone() {
                return this.location.left_at;
            },
            isStandBy() {
                return this.order.reserved_at && ! this.location.arrived_at && this.locationIndex == 0
            },
            isWait() {
                return !this.isProcessing ||
                    (this.previous && !this.previous.left_at);
            },
            isNow() {
                return !this.location.left_at &&
                    (!this.previous || this.previous.left_at) &&
                    this.isProcessing &&
                    ! this.isStandBy;
            },
            isLast() {
                return (this.locationIndex + 1) === this.locations.length;
            },
            timeStyle() {
                return {
                    'done': this.isDone,
                    'wait': this.isWait || this.isStandBy,
                    'now': this.isNow,
                    'last': this.isLast,
                }
            },
            reservedAt() {
                if (! this.order.reserved_at) {
                    return '';
                }

                return moment(this.order.reserved_at).format('MM/DD HH:mm');
            },
        }
    };
</script>

<style lang="scss" scoped>
    .time {
        display: flex;
        margin-top: 10px;
        min-height: 65px;

        .glow {
            margin-top: 15px;
            border-radius: 90px;
            position: relative;
        }

        .task {
            margin-left: 20px;
            flex: 1;
            display: flex;
            padding: 10px 15px;
            justify-content: space-between;
            align-items: center;

            .content {
                text-align: left;
                width: 100%;

                .status {
                    font-size: 14px;
                    font-weight: 600;
                    /*display: flex;*/
                    /*align-items: center;*/

                    .round-trip {
                        float: right;
                        border-radius: 10.5px;
                        background-color: #4A4A4A;
                        color: #FFFFFF;
                        font-size: 12px;
                        font-weight: 500;
                        letter-spacing: 0;
                        line-height: 17px;
                        padding: 2px 10px;
                        user-select: none;
                    }
                }

                .address {
                    font-size: 14px;
                    color: #4A4A4A;
                    line-height: 20px;
                }

                .description {
                    font-size: 12px;
                    margin-top: 8px;

                    &.blue {
                      color: #4A90E2;
                    }
                }
            }

            .buttons {
                .button {
                    background-color: #4A90E2;
                    border-radius: 12.5px;
                    padding: 3px 10px;
                    font-size: 14px;
                    cursor: pointer;
                }
            }
        }
    }

    .err {
        color: #FFFFFF;

        .glow {
            background-color: #F44336 !important;
            box-shadow: 0 0 5px rgba(244,67,54,.2) !important;

            &::after {
                background-color: rgba(244,67,54,.45) !important;
            }

            &::before {
                background-color: rgba(244,67,54,.2) !important;
            }
        }

        .task {
            background-color: #F44336 !important;

            .buttons {
                .button {
                    background-color: #4A4A4A !important;
                }
            }
        }
    }

    .now {
        color: #FFFFFF;

        .glow {
            width: 12px;
            height: 12px;
            background-color: #339933;
            border-radius: 90px;
            box-shadow: 0 0 5px rgba(0,255,0,.2);
            animation: glow-1 800ms ease-out infinite alternate;

            &::after {
                content: '';
                top: 0;
                left: 0;
                position:absolute;
                width:12px;
                height: 12px;
                border-radius: 90px;
                background-color: rgba(51,153,51,.45);
                animation: glow-2 800ms ease-out infinite alternate;
            }

            &::before {
                content: '';
                top: 0;
                left: 0;
                position:absolute;
                width:12px;
                height: 12px;
                border-radius: 90px;
                background-color: rgba(51,153,51,.2);
                animation: glow-3 800ms ease-out infinite alternate;
            }
        }

        .task {
            background-color: #339933;
            border-radius: 5px;

            .content {
                .address {
                    color: #FFFFFF;
                }
            }
        }
    }

    .wait {
        .glow {
            margin-left: -3px;
            width: 18px;
            height: 18px;
            background-color: #D8D8D8;
        }

        .task {
            .content {
                .description {
                    color: #9b9b9b;
                }
            }
        }
    }

    .done {
        .task {
            color: #9B9B9B;
        }

        .glow {
            margin-left: -3px;
            width: 18px;
            height: 18px;
            background-color: #fff;

            &::after {
                content: '';
                top: 0;
                left: 0;
                position: absolute;
                width: 18px;
                height: 18px;
                border-radius: 90px;
                background-color: rgba(51,153,51, .4);
            }

            &::before {
                content: "";
                position: absolute;
                width: 5px;
                height: 9px;
                border-bottom: 2px solid #fff;
                border-right: 2px solid #fff;
                transform: rotate(45deg);
                z-index: 10;
                top: 2px;
                left: 6px;
            }
        }
    }

    .last {
        &.time {
            position: relative;

            &::after {
                content: '終點';
                height: 16px;
                color: #9B9B9B;
                font-size: 11px;
                position: absolute;
                left: -6px;
                top: 33px;
                width: 25px;
            }
        }
    }

    @keyframes glow-3 {
        0% {
            transform: scale(1);
        }

        100% {
            transform: scale(2);
        }
    }

    @keyframes glow-2 {
        0% {
            transform: scale(1);
        }

        100% {
            transform: scale(1.6);
        }
    }

    @keyframes glow-1 {
        0% {
            transform:scale(1);
        }
        100% {
            transform:scale(1.2);
        }
    }
</style>
